import { DrawerStyles, DrawerTemplate } from "@fluentui/web-components";
import { DesignSystem } from "../design-system.js";
import { Drawer } from "./drawer.js";
/**
 * The Fabric Drawer component.
 *
 * @public
 */
export const definition = Drawer.compose({
    name: `${DesignSystem.prefix}-drawer`,
    template: DrawerTemplate,
    styles: DrawerStyles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=drawer.definition.js.map